import "./ProjectManagement.css";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { ProjectManagementBannerSection } from "./ProjectManagementBannerSection";
import { ProjectManagementDescriptionSection } from "./ProjectManagementDescriptionSection";

export const ProjectManagement = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>VH BuildUp! - {t("helmet.title.project")}</title>
        <meta name="description" content={t("helmet.meta.project")} />
      </Helmet>
      <ProjectManagementBannerSection />
      <ProjectManagementDescriptionSection />
    </>
  );
};
